import { DraggableComponent } from '../../draggable/draggable.component';

export class DraggableComponentEvent extends Event {
  constructor(
    type: string,
    public readonly draggableComponent: DraggableComponent,
  ) {
    super(type);
  }
}
